import { render, staticRenderFns } from "./MzReviews.vue?vue&type=template&id=f638b3d6&"
import script from "./MzReviews.vue?vue&type=script&lang=js&"
export * from "./MzReviews.vue?vue&type=script&lang=js&"
import style0 from "./MzReviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports